import React, { useEffect, useMemo } from 'react';

export function generateId(length: number): string {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

const applyTrap = (id: string) => {
  if (!window.appliedModals) {
    window.appliedModals = new Set();
  }
  window.appliedModals.add(id);
  // while backdrop is shown user should not be able to scroll
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
};

const unapplyTrap = (id: string) => {
  if (!window.appliedModals) {
    window.appliedModals = new Set();
  }
  window.appliedModals.delete(id);
  if (window.appliedModals.size === 0) {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }
};

interface ScrollTrapProps {
  children: React.ReactNode;
  isActive: boolean;
  idLength?: number;
}

const ScrollTrap: React.FC<ScrollTrapProps> = ({ children, isActive, idLength = 5 }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const id = useMemo(() => generateId(idLength), []);

  useEffect(() => {
    if (isActive) {
      applyTrap(id);
    } else {
      unapplyTrap(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => unapplyTrap(id), []);

  return children;
};

export default ScrollTrap;
